import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () => import(/* webpackChunkName: "mars", webpackPrefetch: true */ './Mars'),
  loading: () => <PleaseWait />,
});
